import * as Icons from "@nova/component-icons"
import classNames from "classnames"

export const UserLocationFlyoutLayersPanelTrigger = ({
    entityCount,
    open,
}: {
    entityCount: number
    open: boolean
}) => {
    if (entityCount < 1) return null
    return (
        <div
            className={classNames("px-1.5 py-1 flex items-center gap-1 rounded-lg border group", {
                "border-transparent hover:bg-white-200": !open,
                "border-white-300 bg-white-200": open,
            })}
        >
            <div
                className={classNames(
                    "leading-none px-1.5 flex justify-center items-center rounded-full h-4 min-w-[30px] shrink-0 font-mono text-xs transition-colors bg-white-100",
                    { "text-white-400 group-hover:text-white-600": !open, "text-white-600": open }
                )}
            >
                {entityCount}
            </div>
            <Icons.Icon Icon={Icons.AtlasNoBg} />
        </div>
    )
}
